import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonDirective } from '../../directives/button.directive';
import { SvgComponent } from '../svg/svg.component';

@Component({
  selector: 'app-sorting-button',
  imports: [ButtonDirective, SvgComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './sorting-button.component.html',
  styleUrl: './sorting-button.component.scss',
})
export class SortingButtonComponent {
  active = input.required<boolean>();
  name = input.required<string>();
  location = input.required<string>();
  flipped = input.required<boolean>();
  randomized = input<boolean>();
  allowFlip = input<boolean>(true);
  allowRandom = input<boolean>(false);
  activeChanged = output<boolean>();
  flippedChanged = output<void>();
  randomChanged = output<void>();
}
